// reports views
import Reports from '@/views/Reports.vue';

// import MainReport from '@/views/Reports/MainReport.vue';
// import PaymentsReport from '@/views/Reports/PaymentsReport.vue';
// import PaymentsSubReport from '@/views/Reports/PaymentsSubReport.vue';
import CustomReport from '@/views/Reports/CustomReport.vue';
import CohortReport from '@/views/Reports/CohortReport.vue';

export default [
  {
    path: '/reports',
    component: Reports,
    meta: {
      requiresAuth: true,
      view: 'reports',
    },
    children: [
      {
        path: 'cohort',
        component: CohortReport,
        name: 'reports.cohort',
        meta: {
          view: 'cohort',
        },
      },
      // {
      //   path: 'main/:type',
      //   component: MainReport,
      //   name: 'main-report',
      //   meta: {
      //     view: 'main-report',
      //   },
      // },
      // {
      //   path: 'payments',
      //   component: PaymentsReport,
      //   name: 'payments',
      //   meta: {
      //     view: 'payments',
      //   },
      // },
      // {
      //   path: 'payments/sub',
      //   component: PaymentsSubReport,
      //   name: 'payments-sub',
      //   meta: {
      //     view: 'payments',
      //   },
      // },
      {
        path: 'custom',
        component: CustomReport,
        name: 'reports.custom-report',
        meta: {
          view: 'custom-report',
        },
      },
      {
        path: '',
        name: 'reports.empty',
        redirect: 'reports/custom',
      },
      {
        path: ':catchAll(.*)',
        name: 'reports.catch-all',
        redirect: 'reports/custom',
      },
    ],
  },
];
